'use es6';

import BusinessUnitLabel from 'EmailComponents/businessUnits/BusinessUnitLabel';
import EmailTypeSelectableButtons from 'EmailComponents/emailCreation/EmailTypeSelectableButtons';
import { getBuNameById } from 'EmailComponents/utils/businessUnit';
import getBUFromLocalStorage, { ALL_BUSINESS_UNITS, DEFAULT_ACCOUNT_BUSINESS_UNIT_ID } from 'EmailComponents/utils/getBUFromLocalStorage';
import { EMAIL_TEMPLATE_MODE_MODAL_TYPES as MODAL_TYPES } from 'EmailData/constants/emailCreation';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import PropTypes from 'prop-types';
import { Component } from 'react';
import BusinessUnitSelect from 'ui-business-units-lib/components/BusinessUnitSelect';
import { BusinessUnitsRebrandMessage } from 'ui-business-units-lib/components/BusinessUnitsRebrandMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class EmailTypeSelectModalBody extends Component {
  constructor(props) {
    super(props);
    this.getShouldUseBUPickerInCreation = () => {
      const {
        creationType,
        shouldUseBUPicker
      } = this.props;
      return shouldUseBUPicker && this.buFromLocalStorage !== ALL_BUSINESS_UNITS && creationType === MODAL_TYPES.CREATE;
    };
    this.onSelectBusinessUnit = buId => {
      if (buId && buId !== DEFAULT_ACCOUNT_BUSINESS_UNIT_ID) {
        this.setState({
          isBusinessUnitSelected: true,
          isAccountSelected: false
        });
      } else if (buId === DEFAULT_ACCOUNT_BUSINESS_UNIT_ID) {
        this.setState({
          isBusinessUnitSelected: false,
          isAccountSelected: true
        });
      } else {
        this.setState({
          isBusinessUnitSelected: false,
          isAccountSelected: false
        });
      }
      this.props.onSelectBusinessUnit(buId);
    };
    this.maybeRenderBULabel = () => {
      if (!this.getShouldUseBUPickerInCreation()) {
        return null;
      }
      return /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        marginBlockEnd: "100",
        inlineSize: "370px",
        "data-test-id": "creation-bu-label",
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(UIFormControl, {
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "EmailComponents.businessUnits.label"
            }),
            tooltip: this.getShouldUseBUPickerInCreation() && /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
              message: "EmailComponents.buMigration.buTooltip",
              rebrandMessage: "EmailComponents.buMigration.buTooltip_buv2"
            }),
            children: /*#__PURE__*/_jsx(BusinessUnitLabel, {
              buId: parseInt(this.buFromLocalStorage, 10)
            })
          })
        })
      });
    };
    this.state = {
      isBusinessUnitSelected: false,
      isAccountSelected: false,
      canAccessBusinessUnit: props.canAccessBusinessUnit
    };
    this.buFromLocalStorage = getBUFromLocalStorage();
  }
  componentDidMount() {
    if (this.getShouldUseBUPickerInCreation()) {
      this.onSelectBusinessUnit(this.buFromLocalStorage);
    }
  }
  static getDerivedStateFromProps(newProps, state) {
    const {
      canAccessBusinessUnit
    } = state;
    if (canAccessBusinessUnit && newProps.buOptions.length === 1) {
      return {
        isAccountSelected: true,
        canAccessBusinessUnit: newProps.canAccessBusinessUnit
      };
    }
    return {
      isAccountSelected: state.isAccountSelected,
      canAccessBusinessUnit: newProps.canAccessBusinessUnit
    };
  }
  maybeRenderBusinessUnitSelectDropdown() {
    const {
      canAccessBusinessUnit,
      creationType,
      buOptions,
      emailBusinessUnitId,
      emailName
    } = this.props;
    if (this.getShouldUseBUPickerInCreation()) {
      return null;
    }
    return canAccessBusinessUnit && /*#__PURE__*/_jsxs(Flex, {
      align: "stretch",
      "data-test-id": "email-modal-business-unit-select",
      marginBlockEnd: "400",
      inlineSize: creationType === MODAL_TYPES.CREATE || creationType === MODAL_TYPES.CLONE ? '370px' : undefined,
      justify: "center",
      direction: "column",
      children: [creationType === MODAL_TYPES.CLONE && /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          "data-test-id": "email-cross-clone-bu-info",
          message: "EmailComponents.modals.businessUnit.originalEmailBUInfo",
          options: {
            emailName,
            buName: getBuNameById(emailBusinessUnitId, buOptions)
          }
        })
      }), /*#__PURE__*/_jsx(BusinessUnitSelect, {
        buOptions: buOptions,
        withHeader: true,
        onChange: this.onSelectBusinessUnit
      })]
    });
  }
  shouldRenderEmailTypeSelectOption() {
    const {
      canAccessBusinessUnit
    } = this.props;
    const {
      isBusinessUnitSelected,
      isAccountSelected
    } = this.state;
    if (!canAccessBusinessUnit || this.getShouldUseBUPickerInCreation()) return true;
    return isBusinessUnitSelected || isAccountSelected;
  }
  render() {
    const {
      availableEmailTypes,
      creationType,
      onSelectType,
      showNonConvertibleMessage,
      selectedEmailType
    } = this.props;
    const modalType = creationType === MODAL_TYPES.CLONE ? 'cross-bu-clone' : creationType;
    return /*#__PURE__*/_jsxs("div", {
      "data-test-id": `email-${modalType}-modal-container`,
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        align: "stretch",
        justify: "center",
        direction: "column",
        children: [this.maybeRenderBusinessUnitSelectDropdown(), this.maybeRenderBULabel(), /*#__PURE__*/_jsx(EmailTypeSelectableButtons, {
          availableEmailTypes: availableEmailTypes,
          creationType: creationType,
          selectedEmailType: selectedEmailType,
          shouldRenderEmailTypeSelectOption: this.shouldRenderEmailTypeSelectOption(),
          onSelectType: onSelectType
        })]
      }), showNonConvertibleMessage && /*#__PURE__*/_jsx(UIAlert, {
        className: "m-top-2 m-x-10",
        type: "info",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "EmailComponents.modals.creation.chooseEmailType.notConvertible"
        })
      })]
    });
  }
}
EmailTypeSelectModalBody.propTypes = {
  availableEmailTypes: PropTypes.array.isRequired,
  buOptions: PropTypes.array.isRequired,
  canAccessBusinessUnit: PropTypes.bool.isRequired,
  onSelectType: PropTypes.func.isRequired,
  creationType: PropTypes.string.isRequired,
  emailBusinessUnitId: PropTypes.number,
  emailName: PropTypes.string,
  onSelectBusinessUnit: PropTypes.func.isRequired,
  shouldUseBUPicker: PropTypes.bool,
  showNonConvertibleMessage: PropTypes.bool,
  selectedEmailType: PropTypes.string
};
EmailTypeSelectModalBody.defaultProps = {
  showNonConvertibleMessage: false
};